var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name === 'index')?_c('div',{staticClass:"w-block__footer",class:{
    'w-block__footer--mobile': _vm.$voicer.isMobile,
    'w-block__footer--ios': _vm.$voicer.isIos,
    'w-block__footer--no-player': _vm.isPersistantVisible === false,
  }},[_c('exc-dialog')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }